import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { attributeSelect as AttributeSelect } from 'theme/icon';
import { VelocityComponent, VelocityTransitionGroup } from 'velocity-react';
import { Tooltip } from 'antd';
import _ from 'lodash';
import styles from './styles.scss';
import CustomScroll from '../../../../../CustomTender/control/scroll';

const Block = props => {
  const { item, options } = props;
  const getSelectOptionName = (id, arr = options) => {
    let value;
    for (let i = 0; i < arr.length; i += 1) {
      if (arr[i].id === id) {
        value = arr[i].name;
        break;
      }

      if (arr[i].children) {
        value = getSelectOptionName(id, arr[i].children);
        if (value) {
          break;
        }
      }
    }
    return value;
  };
  return (
    <div className={styles.block}>
      {item && (
        <React.Fragment>
          {item.value && <div className={styles.name}>{getSelectOptionName(item.value, options)}</div>}
          {item.comment && <div className={styles.comment}>{item.comment}</div>}
        </React.Fragment>
      )}
    </div>
  );
};

Block.propTypes = {
  options: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  item: PropTypes.objectOf(PropTypes.any).isRequired,
};

const SelectAttribute = props => {
  const isShowArrow = props.isEditable;
  const isChanged = props.meta.dirty;
  const { delay } = props;
  return (
    <React.Fragment>
      <div className={cn(styles.row, styles.select)}>
        <div className={styles.header}>
          <div className={styles.icon}>
            <AttributeSelect alt="" />
          </div>
          <div className={styles.caption}>
            <Tooltip placement="bottomLeft" title={props.name.length > 25 ? props.name : null}>
              <h4>{_.truncate(props.name, { omission: '...', length: 25 })}</h4>
            </Tooltip>
          </div>
        </div>
        <div className={styles.body}>
          {props.value && (
            <CustomScroll universal style={{ width: 275, height: 86 }}>
              <Block item={props.value && props.value.parent} options={props.options} />
              <Block item={props.value && props.value.child} options={props.options} />
            </CustomScroll>
          )}
        </div>
      </div>
      <VelocityTransitionGroup
        enter={{
          animation: {
            borderTopColor: ['#FFA037', '#FFFFFF'],
          },
          duration: 100,
          delay,
        }}
        leave={{
          animation: {
            borderTopColor: ['#FFFFFF', '#FFA037'],
          },
          duration: 300,
        }}
      >
        {isShowArrow && (
          <VelocityComponent
            runOnMount
            animation={{
              borderTopColor: isChanged ? '#FFA037' : '#1B9CFB',
            }}
            duration={100}
            delay={delay}
          >
            <span className={styles.arrowTop} />
          </VelocityComponent>
        )}
      </VelocityTransitionGroup>
      <VelocityTransitionGroup
        enter={{
          animation: {
            borderTopColor: ['#FFFBEF', '#FFFFFF'],
          },
          duration: 100,
          delay,
        }}
        leave={{
          animation: {
            borderTopColor: ['#FFFFFF', '#FFFBEF'],
          },
          duration: 300,
        }}
      >
        {isShowArrow && (
          <VelocityComponent
            animation={{
              borderTopColor: isChanged ? '#FFFBEF' : '#E5EFFF',
            }}
            duration={100}
            delay={delay}
          >
            <span className={styles.arrowBottom} />
          </VelocityComponent>
        )}
      </VelocityTransitionGroup>
    </React.Fragment>
  );
};

SelectAttribute.propTypes = {
  name: PropTypes.string.isRequired,
  delay: PropTypes.number.isRequired,
  isEditable: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  value: PropTypes.objectOf(PropTypes.any),
};

SelectAttribute.defaultProps = {
  value: null,
};

export default SelectAttribute;
